import { render } from "./Instructor.vue?vue&type=template&id=5954a4ec&scoped=true"
import script from "./Instructor.vue?vue&type=script&lang=js"
export * from "./Instructor.vue?vue&type=script&lang=js"

import "./Instructor.vue?vue&type=style&index=0&id=5954a4ec&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\2. Fabrica 2022\\Proyecto_Andres_Fabrica\\proyecto_llaves\\version_principal\\frontend_proyecto_llaves\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5954a4ec"]])

export default __exports__